var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNfctronIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.029,
    height: 75.273,
    viewBox: "0 0 78.029 75.273",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nfctron-plus-obecne",
    transform: "translate(2037.327 -1738.745)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10284",
    "data-name": "Path 10284",
    d: "M-1954.218,1776.342a37.4,37.4,0,0,1-4.687,18.188c-.118.212-.236.422-.358.633-.047.079-.093.161-.14.24-.129.222-.265.444-.4.662-.1.161-.2.318-.3.479-.032.05-.064.1-.1.154q-.923,1.433-1.968,2.773c-.093.118-.186.24-.286.358a37.619,37.619,0,0,1-17.963,12.356,37.6,37.6,0,0,1-11.4,1.757,37.617,37.617,0,0,1-10.18-1.4,36.581,36.581,0,0,1-4.913-1.76c-.154-.064-.308-.132-.458-.2a37.6,37.6,0,0,1-22.046-34.244,38.058,38.058,0,0,1,.447-5.818c.007-.05.014-.1.025-.147a37.149,37.149,0,0,1,1.721-6.713c.018-.057.039-.111.061-.168a37.606,37.606,0,0,1,35.343-24.751A37.6,37.6,0,0,1-1954.218,1776.342Z",
    transform: "translate(-5.081)",
    fill: "#11394d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4349",
    "data-name": "Group 4349",
    transform: "translate(-1988.3 1776.94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10285",
    "data-name": "Path 10285",
    d: "M-1885.572,1849.733a4.774,4.774,0,0,1-3.914,5.319,4.458,4.458,0,0,1-4.843-4.214,4.773,4.773,0,0,1,3.914-5.319A4.457,4.457,0,0,1-1885.572,1849.733Z",
    transform: "translate(1896.486 -1845.487)",
    fill: "#467d6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6506",
    "data-name": "Path 6506",
    d: "M-1886.575,1855.229c-.177-.645-1.467-.622-2.881-.519.082.28.133.352.174.5.468-.008,1.318-.1,1.308.136,0,.11-.383.355-.713.563a15.735,15.735,0,0,1-3.674,1.461,25.446,25.446,0,0,1-5.33,1.089,2.221,2.221,0,0,1-1.031-.124c-.39-.214.181-.562.729-.817a3.9,3.9,0,0,1-.071-.616c-1.546.692-2.354,1.417-1.974,1.936s2.65,1.287,7.357-.066C-1887.113,1857.177-1886.427,1855.769-1886.575,1855.229Z",
    transform: "translate(1900.197 -1851.374)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6506-2",
    "data-name": "Path 6506",
    d: "M-1886.762,1854.712c-.178-.645-1.467-.622-2.881-.519.082.28.133.352.174.5.468-.008,1.318-.1,1.308.136,0,.11-.382.355-.713.564a15.765,15.765,0,0,1-3.674,1.461,25.442,25.442,0,0,1-5.331,1.089,2.213,2.213,0,0,1-1.031-.125c-.389-.214.2-.593.752-.847.009-.207-.037-.345-.026-.572-1.546.692-2.421,1.4-2.042,1.922s2.65,1.287,7.357-.066C-1887.3,1856.659-1886.614,1855.251-1886.762,1854.712Z",
    transform: "translate(1900.314 -1851.042)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4355",
    "data-name": "Group 4355",
    transform: "translate(-1981.314 1752.113)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4350",
    "data-name": "Group 4350",
    transform: "translate(1.432 5.201)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2738",
    "data-name": "Ellipse 2738",
    cx: 0.402,
    cy: 0.402,
    r: 0.402,
    transform: "translate(1.455 1.524)",
    fill: "#4b8f8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10286",
    "data-name": "Path 10286",
    d: "M-1876.754,1791.239c.455-.743,1.706-.805,2.793-.139s1.6,1.809,1.144,2.552c-.012.019-.024.038-.038.056l-3.932-2.41C-1876.777,1791.278-1876.766,1791.258-1876.754,1791.239Z",
    transform: "translate(1876.787 -1790.638)",
    fill: "#f6f6f6"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_711",
    "data-name": "Rectangle 711",
    width: 5.748,
    height: 0.322,
    transform: "matrix(-0.853, -0.523, 0.523, -0.853, 7.09, 5.913)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4352",
    "data-name": "Group 4352",
    transform: "translate(3.252 1.498)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2739",
    "data-name": "Ellipse 2739",
    cx: 0.438,
    cy: 0.602,
    rx: 0.438,
    ry: 0.602,
    transform: "matrix(0.523, -0.853, 0.853, 0.523, 2.404, 0.747)",
    fill: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4351",
    "data-name": "Group 4351",
    transform: "translate(0 0.236)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_712",
    "data-name": "Rectangle 712",
    width: 2.129,
    height: 0.717,
    rx: 0.358,
    transform: "matrix(-0.853, -0.523, 0.523, -0.853, 3.616, 1.724)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_713",
    "data-name": "Rectangle 713",
    width: 3.804,
    height: 2.13,
    transform: "matrix(0.523, -0.853, 0.853, 0.523, 0, 3.548)",
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_714",
    "data-name": "Rectangle 714",
    width: 0.569,
    height: 2.13,
    transform: "matrix(0.523, -0.853, 0.853, 0.523, 0.295, 3.068)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_715",
    "data-name": "Rectangle 715",
    width: 0.569,
    height: 2.13,
    transform: "matrix(0.523, -0.853, 0.853, 0.523, 1.239, 1.527)",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4353",
    "data-name": "Group 4353",
    transform: "translate(5.797 3.577)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_716",
    "data-name": "Rectangle 716",
    width: 4.376,
    height: 2.43,
    transform: "matrix(0.523, -0.853, 0.853, 0.523, 0, 3.731)",
    fill: "#25566e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_717",
    "data-name": "Rectangle 717",
    width: 4.376,
    height: 0.072,
    transform: "matrix(0.523, -0.853, 0.853, 0.523, 1.011, 4.351)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10287",
    "data-name": "Path 10287",
    d: "M-1862.782,1793.383l1,.613.073.045,1,.613-.043.07-1-.613-.073-.045-1-.613Z",
    transform: "translate(1863.457 -1790.777)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_718",
    "data-name": "Rectangle 718",
    width: 0.083,
    height: 2.43,
    transform: "matrix(0.523, -0.853, 0.853, 0.523, 1.475, 1.342)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4354",
    "data-name": "Group 4354",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_719",
    "data-name": "Rectangle 719",
    width: 4.376,
    height: 2.43,
    transform: "matrix(0.523, -0.853, 0.853, 0.523, 0, 3.731)",
    fill: "#25566e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_720",
    "data-name": "Rectangle 720",
    width: 4.376,
    height: 0.072,
    transform: "matrix(0.523, -0.853, 0.853, 0.523, 1.011, 4.351)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10288",
    "data-name": "Path 10288",
    d: "M-1878.982,1783.386l1,.613.073.045,1,.613-.043.07-1-.613-.073-.045-1-.613Z",
    transform: "translate(1879.657 -1780.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_721",
    "data-name": "Rectangle 721",
    width: 0.083,
    height: 2.43,
    transform: "matrix(0.523, -0.853, 0.853, 0.523, 1.475, 1.342)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10289",
    "data-name": "Path 10289",
    d: "M-2013.78,1894.436q.966,1.514,2.068,2.927a37.528,37.528,0,0,0,29.646,14.47,37.617,37.617,0,0,0,10.18-1.4,37.241,37.241,0,0,0,5.371-1.961,35.907,35.907,0,0,0-3.313-4.544c-.125-.143-.247-.286-.376-.429v0a36.8,36.8,0,0,0-13.143-9.443,37.682,37.682,0,0,0-14.789-2.992,37.845,37.845,0,0,0-3.95.2,37.282,37.282,0,0,0-5.174.9A36.965,36.965,0,0,0-2013.78,1894.436Z",
    transform: "translate(-15.121 -97.816)",
    fill: "#484d6c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3045",
    "data-name": "Group 3045",
    transform: "translate(-2018.981 1749.198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8082",
    "data-name": "Path 8082",
    d: "M-1973.391,1792.8c.472,2.37-1.729,4.83-4.914,5.493s-6.149-.719-6.62-3.089,1.729-4.831,4.915-5.493S-1973.863,1790.435-1973.391,1792.8Z",
    transform: "translate(1985.371 -1781.823)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8083",
    "data-name": "Path 8083",
    d: "M-1966.956,1793.572c.682,1.737-.763,2.813-2.84,3.407s-4.168.685-4.68-1.256c-.507-1.92.913-3.3,2.989-3.9S-1967.708,1791.659-1966.956,1793.572Z",
    transform: "translate(1978.686 -1783.126)",
    fill: "#11394d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8084",
    "data-name": "Path 8084",
    d: "M-1980.642,1812.211c.337.424.206.942-.516,1.292-1.115.541-3.346,1.563-2.934,3.245a65.372,65.372,0,0,1,1.585,7.272c-.059.842-.528,7.092-.644,7.573s-2.7,14.85-2.759,15.084c-.528,2.044.411,4.147,2.231,1.082,1-1.652,5.224-14.423,5.224-16.166.91-.15,1.209-.238,1.209-.238s-.792,13.49-1.033,15.2c-.352,2.163.644,4.327,2.113.721,1.7-4,3.679-16.752,3.328-20.208,0-3.305-1.132-7.64-1.1-9.39a3.958,3.958,0,0,0,.646-.254l-.241-3.6s-2.924-.918-3.159-.918-.881-1.022-.881-1.022Z",
    transform: "translate(1986.057 -1796.163)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8085",
    "data-name": "Path 8085",
    d: "M-1965.3,1828.18a26.94,26.94,0,0,1-5.26.749c-.059-1.26-.364-4.225-.364-4.225a48.825,48.825,0,0,0,5.208-1.152A9.461,9.461,0,0,1-1965.3,1828.18Z",
    transform: "translate(1976.337 -1803.659)",
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3015",
    "data-name": "Group 3015",
    transform: "translate(4.72 9.691)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8086",
    "data-name": "Path 8086",
    d: "M-1971.715,1796.078c-.628.591-1.028,1.382-1.117,1.266s-.065-.937.806-1.6a2.014,2.014,0,0,1,1.531-.5C-1970.407,1795.364-1971.14,1795.536-1971.715,1796.078Z",
    transform: "translate(1972.867 -1795.151)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8087",
    "data-name": "Path 8087",
    d: "M-1964.63,1795.378a.289.289,0,0,1-.35.011c-.072-.075-.031-.2.09-.283a.289.289,0,0,1,.35-.011C-1964.468,1795.17-1964.509,1795.3-1964.63,1795.378Z",
    transform: "translate(1967.824 -1795.041)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8088",
    "data-name": "Path 8088",
    d: "M-1951.6,1803.575s-.677-2.134-.115-2.666c2.473-.453,3.347.148,2.066-2.761-.817-1.491-1.825-2.972-2.288-4.111-.263-.63-.366-3.766,1.7-1.38a22.461,22.461,0,0,1,3.432,6.311c.939,2.779.029,3.5-.91,4.207a12.209,12.209,0,0,1-4.051,1.322",
    transform: "translate(1964.236 -1783.252)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8089",
    "data-name": "Path 8089",
    d: "M-1951.742,1779.458c.057.175-13.77,4.33-14.258,4.535-2.492-.751-1.208-3.146-1.208-3.146l13.061-8.054Z",
    transform: "translate(1974.165 -1771.062)",
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8090",
    "data-name": "Path 8090",
    d: "M-1928.265,1775.164c.537,1.947.263,3.729-.612,3.982s-2.019-1.12-2.556-3.066-.262-3.729.612-3.982S-1928.8,1773.216-1928.265,1775.164Z",
    transform: "translate(1951.155 -1770.597)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8091",
    "data-name": "Path 8091",
    d: "M-1979.209,1809.863s1.526-2.163,2.29-2.224c.644.6.939,1.5,1.35,1.5.205-.388,1.375-5.9,1.878-6.971.176-.661,2-3.185,2.172,0a32.689,32.689,0,0,1-2.407,9.676,1.857,1.857,0,0,1-2.407.841,8.218,8.218,0,0,1-3.307-2.183",
    transform: "translate(1981.936 -1788.918)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8092",
    "data-name": "Path 8092",
    d: "M-1969.687,1806.752a46.267,46.267,0,0,1-1.478,5.451c-.35.161-1.209-1.181-1.856-1.783-.234-.064.233-.114.333-.121.644.6.939,1.5,1.349,1.5.358-.671,1.5-6.171,1.88-6.97C-1969.16,1804.781-1969.581,1806.144-1969.687,1806.752Z",
    transform: "translate(1977.727 -1791.636)",
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8093",
    "data-name": "Path 8093",
    d: "M-1952.6,1819.926c-.243.036-.59-1-.774-2.314s-.138-2.408.105-2.444.589,1,.774,2.315S-1952.355,1819.89-1952.6,1819.926Z",
    transform: "translate(1965.14 -1798.274)",
    fill: "#50c878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8094",
    "data-name": "Path 8094",
    d: "M-1948.238,1819.926c-.243.036-.59-1-.774-2.314s-.138-2.408.105-2.444.589,1,.774,2.315S-1948,1819.89-1948.238,1819.926Z",
    transform: "translate(1962.34 -1798.274)",
    fill: "#50c878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8095",
    "data-name": "Path 8095",
    d: "M-1977.156,1820.3c.164.186-.527,1.1-1.544,2.04s-1.976,1.551-2.139,1.364.527-1.1,1.544-2.04S-1977.321,1820.119-1977.156,1820.3Z",
    transform: "translate(1982.722 -1801.552)",
    fill: "#50c878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8096",
    "data-name": "Path 8096",
    d: "M-1974.07,1821.727c.19.154-.354,1.181-1.216,2.3s-1.715,1.892-1.905,1.738.354-1.181,1.217-2.3S-1974.26,1821.575-1974.07,1821.727Z",
    transform: "translate(1980.388 -1802.475)",
    fill: "#50c878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8097",
    "data-name": "Path 8097",
    d: "M-1938.529,1776.595c-.845.274-1.712.559-2.638.856l-.588.186c-.373.119-.759.238-1.157.361-.192.059-.385.117-.583.179-.277.083-.573.166-.882.25-.2.054-.4.107-.6.164l-.726.195c-.2.052-.4.107-.6.16a7.849,7.849,0,0,1-1.87-5.991l.005,0c.146-.1.312-.205.491-.326.218-.146.458-.308.713-.483l.481-.326.837-.573.463-.317c.391-.269.782-.539,1.161-.8l.447-.309c1.291-.894,2.309-1.6,2.309-1.6Z",
    transform: "translate(1961.759 -1768.123)",
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8098",
    "data-name": "Path 8098",
    d: "M-1927.217,1771.786c.683,2.363.53,4.494-.341,4.759s-2.133-1.438-2.815-3.8-.531-4.494.341-4.759S-1927.9,1769.422-1927.217,1771.786Z",
    transform: "translate(1950.573 -1767.958)",
    fill: "#11394d",
    stroke: "#c3c3c3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8099",
    "data-name": "Path 8099",
    d: "M-1945.658,1786.7c-.2.052-.4.107-.6.16a8.5,8.5,0,0,1-1.865-5.995c.146-.1.312-.205.491-.326A8.6,8.6,0,0,0-1945.658,1786.7Z",
    transform: "translate(1961.711 -1776.036)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8100",
    "data-name": "Path 8100",
    d: "M-1942.143,1784.886c-.2.054-.4.107-.6.164a9.909,9.909,0,0,1-1.983-6.449q.232-.157.481-.326A10,10,0,0,0-1942.143,1784.886Z",
    transform: "translate(1959.525 -1774.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8101",
    "data-name": "Path 8101",
    d: "M-1928.327,1771.952c-.059.706.146,1.414.021,1.39a1.34,1.34,0,0,1-.417-1.431c.13-.65.573-1.155.7-1.131S-1928.274,1771.306-1928.327,1771.952Z",
    transform: "translate(1949.263 -1769.769)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8102",
    "data-name": "Path 8102",
    d: "M-1958.625,1794.219a6.322,6.322,0,0,1-.778-4.077v0l.529-.337c0,.005,0,.011,0,.016a6.761,6.761,0,0,0,.77,4.241Z",
    transform: "translate(1968.999 -1781.985)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8103",
    "data-name": "Path 8103",
    d: "M-1955.04,1792.586a8.08,8.08,0,0,1-.951-4.493v-.014l-.52.33v0a7.438,7.438,0,0,0,.954,4.332Z",
    transform: "translate(1967.114 -1780.879)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8104",
    "data-name": "Path 8104",
    d: "M-1980.74,1895.176c-.553,1.625-1.094,3.13-1.528,4.239a16.289,16.289,0,0,1-2.742-.674c.174-.955.429-2.356.71-3.9A33.81,33.81,0,0,0-1980.74,1895.176Z",
    transform: "translate(1985.385 -1849.435)",
    fill: "#50c878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8105",
    "data-name": "Path 8105",
    d: "M-1960.5,1895.369c-.326,1.539-.673,2.944-1.022,4.075a21.153,21.153,0,0,1-2.555-.163c.075-.869.168-2.162.267-3.618C-1962.732,1895.631-1961.4,1895.484-1960.5,1895.369Z",
    transform: "translate(1971.939 -1849.778)",
    fill: "#50c878"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2740",
    "data-name": "Ellipse 2740",
    cx: 0.358,
    cy: 0.358,
    r: 0.358,
    transform: "translate(-1986.756 1751.36)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2741",
    "data-name": "Ellipse 2741",
    cx: 0.895,
    cy: 0.895,
    r: 0.895,
    transform: "translate(-1986.398 1764.958)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2742",
    "data-name": "Ellipse 2742",
    cx: 0.358,
    cy: 0.358,
    r: 0.358,
    transform: "translate(-1966.36 1765.315)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2743",
    "data-name": "Ellipse 2743",
    cx: 0.537,
    cy: 0.537,
    r: 0.537,
    transform: "translate(-1974.59 1771.756)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2744",
    "data-name": "Ellipse 2744",
    cx: 0.716,
    cy: 0.716,
    r: 0.716,
    transform: "translate(-1967.076 1783.922)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2745",
    "data-name": "Ellipse 2745",
    cx: 0.358,
    cy: 0.358,
    r: 0.358,
    transform: "translate(-1974.232 1793.226)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2746",
    "data-name": "Ellipse 2746",
    cx: 0.716,
    cy: 0.716,
    r: 0.716,
    transform: "translate(-1994.986 1786.785)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2747",
    "data-name": "Ellipse 2747",
    cx: 0.537,
    cy: 0.537,
    r: 0.537,
    transform: "translate(-2026.833 1767.462)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2748",
    "data-name": "Ellipse 2748",
    cx: 0.537,
    cy: 0.537,
    r: 0.537,
    transform: "translate(-2012.52 1747.782)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2749",
    "data-name": "Ellipse 2749",
    cx: 0.537,
    cy: 0.537,
    r: 0.537,
    transform: "translate(-2023.97 1787.143)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2750",
    "data-name": "Ellipse 2750",
    cx: 0.716,
    cy: 0.716,
    r: 0.716,
    transform: "translate(-1999.28 1775.335)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2751",
    "data-name": "Ellipse 2751",
    cx: 0.358,
    cy: 0.358,
    r: 0.358,
    transform: "translate(-2001.427 1742.772)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2752",
    "data-name": "Ellipse 2752",
    cx: 0.537,
    cy: 0.537,
    r: 0.537,
    transform: "translate(-1984.251 1798.951)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6154",
    "data-name": "Path 6154",
    d: "M-1894.955,1896.472c-3.976,1.67-7.838,1.76-7.456.536s6.189-3.075,10.064-5.549,6.748-4.589,4.063-4.135-2.015-.818,1.366-2.493,6.617-2.465,9.76-6.922c2.814-4.827,2.84-6.647,2.84-6.647s.079,10.266-6.874,17.261A34.348,34.348,0,0,1-1894.955,1896.472Z",
    transform: "translate(-86.623 -85.099)",
    fill: "#3e7d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10290",
    "data-name": "Path 10290",
    d: "M-2021.551,1755.379s-9.636,7.69-4.471,9.485c3.579,1.243,4.436-1.76,6.959-5.2,2.528-3.41,3.444-5.35,9.2-8.14,5.815-2.5,5.568-4.281,1.607-3.047A40.753,40.753,0,0,0-2021.551,1755.379Z",
    transform: "translate(-6.283 -5.991)",
    fill: "#c3979c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10291",
    "data-name": "Path 10291",
    d: "M-2035.38,1790.1s-4.771,11.368.623,10.467c3.736-.625,3.049-3.671,3.615-7.9.584-4.2.458-6.346,4.172-11.553,3.9-4.986,2.835-6.427-.051-3.444A40.752,40.752,0,0,0-2035.38,1790.1Z",
    transform: "translate(0 -24.003)",
    fill: "#4b8f8a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNfctronIcon01);
export default __webpack_public_path__ + "static/media/nfctron-icon-01.ae9ecfb32b331aae457f3b116770fce2.svg";
export { ForwardRef as ReactComponent };